(() => {
  'use strict';
  const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/ł/g, 'l').trim();
  function initialise(root) {
    if (root.dataset.encyInitialised) return;
    const controls = root.querySelector('[data-search-controls]');
    if (!controls) return;
    const query = root.querySelector('[data-note-query]');
    const entries = [...root.querySelectorAll('[data-note-entry]')];
    const status = root.querySelector('[data-note-status]');
    const empty = root.querySelector('[data-note-empty]');
    if (!query || !status || !empty) return;
    root.dataset.encyInitialised = 'true';
    const index = entries.map(element => ({element, text: normalise(element.dataset.noteSearch || ''), family: element.dataset.noteFamily}));
    const update = () => {
      const terms = normalise(query.value).split(/\s+/).filter(Boolean);
      const family = controls.querySelector('input[type=radio]:checked')?.value || 'all';
      let count = 0;
      for (const item of index) {
        const show = (family === 'all' || family === item.family) && terms.every(term => item.text.includes(term));
        item.element.hidden = !show;
        if (show) count++;
      }
      status.textContent = `${root.dataset.resultLabel}: ${count} / ${entries.length}`;
      empty.hidden = count !== 0;
    };
    query.addEventListener('input', update);
    controls.addEventListener('change', update);
    root.querySelector('[data-note-clear]')?.addEventListener('click', () => {
      query.value = '';
      const all = controls.querySelector('input[value=all]');
      if (all) all.checked = true;
      update();
      query.focus();
    });
    controls.hidden = false;
    update();
  }
  const boot = container => container.querySelectorAll('[data-bk-encyclopedia]').forEach(initialise);
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

/* Native details keep navigation usable before JavaScript and without it. */
(() => {
  'use strict';
  function initialise(root) {
    const contents = root.querySelector('.bk-ency__contents-disclosure');
    if (!contents || contents.dataset.readerInitialised) return;
    contents.dataset.readerInitialised = 'true';
    const compact = window.matchMedia('(max-width: 900px)');
    const setLayout = () => { contents.open = !compact.matches; };
    setLayout();
    compact.addEventListener('change', setLayout);
    const links = [...contents.querySelectorAll('a[href^="#"]')];
    const sections = links.map(link => document.getElementById(link.hash.slice(1))).filter(Boolean);
    const active = section => {
      for (const link of links) {
        if (link.hash === `#${section.id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    };
    const stickyHeader = document.getElementById('sticky-header');
    const pageHeader = document.getElementById('page-header');
    let queued = false;
    const update = () => {
      queued = false;
      let headerBottom = 0;
      if (stickyHeader) {
        const box = stickyHeader.getBoundingClientRect();
        const position = getComputedStyle(stickyHeader).position;
        if ((position === 'fixed' || position === 'sticky') && box.top <= 1 && box.bottom > 0) headerBottom = box.bottom;
        const enabled = pageHeader?.dataset.sticky === 'true' && (innerWidth >= 1025 || pageHeader?.dataset.stickyMobile === 'true');
        if (enabled) headerBottom = Math.max(headerBottom, box.height);
      }
      const offset = headerBottom + 20;
      root.style.setProperty('--ency-sticky-offset', `${offset}px`);
      let current = sections[0];
      for (const section of sections) if (section.getBoundingClientRect().top <= offset + 35) current = section;
      if (current) active(current);
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    if ('ResizeObserver' in window && stickyHeader) new ResizeObserver(schedule).observe(stickyHeader);
    update();
    contents.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (link && contents.contains(link)) {
        const section = document.getElementById(link.hash.slice(1));
        if (section) active(section);
        if (compact.matches) contents.open = false;
      }
    });
  }
  const boot = container => container.querySelectorAll('[data-bk-encyclopedia]').forEach(initialise);
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

/* Scent articles only: outbound sharing starts with the reader's explicit choice. */
(function () {
  'use strict';
  function safeURL(value) {
    try { var parsed = new URL(value); return parsed.protocol === 'https:' ? parsed : null; }
    catch (_) { return null; }
  }
  function meta(name) {
    var item = document.head.querySelector('meta[property="' + name + '"]');
    return item ? item.content : '';
  }
  function init(root) {
    if (root.dataset.scentShareReady === 'true') return;
    var chooser = root.querySelector('[data-scent-share-chooser]');
    var menu = root.querySelector('[data-scent-share-menu]');
    var summary = root.querySelector('[data-scent-share-summary]');
    var close = root.querySelector('[data-scent-share-close]');
    var copy = root.querySelector('[data-scent-share-copy]');
    var nativeButton = root.querySelector('[data-scent-share-native]');
    var manual = root.querySelector('[data-scent-share-manual]');
    var field = root.querySelector('[data-scent-share-url]');
    var status = root.querySelector('[data-scent-share-status]');
    var canonical = safeURL(root.dataset.url);
    if (!canonical || !chooser || !menu || !summary || !copy || !manual || !field || !status) return;
    canonical.search = ''; canonical.hash = '';
    var url = canonical.href;
    var title = meta('og:title') || root.dataset.title || document.title;
    var description = meta('og:description') || root.dataset.description || '';
    var socialImage = safeURL(meta('og:image') || root.dataset.image);
    var previewImage = root.querySelector('[data-scent-share-image]');
    var previewTitle = root.querySelector('[data-scent-share-title]');
    var previewDescription = root.querySelector('[data-scent-share-description]');
    var previewHost = root.querySelector('[data-scent-share-host]');
    if (previewTitle) previewTitle.textContent = title;
    if (previewDescription) previewDescription.textContent = description;
    if (previewHost) previewHost.textContent = canonical.hostname.replace(/^www\./, '');
    if (previewImage && socialImage) { previewImage.src = socialImage.href; previewImage.hidden = false; }
    var encodedURL = encodeURIComponent(url);
    var encodedTitle = encodeURIComponent(title);
    var intents = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedURL,
      whatsapp: 'https://wa.me/?text=' + encodeURIComponent(title + '\n' + url),
      pinterest: 'https://www.pinterest.com/pin/create/button/?url=' + encodedURL + '&media=' + encodeURIComponent(socialImage ? socialImage.href : '') + '&description=' + encodedTitle,
      telegram: 'https://t.me/share/url?url=' + encodedURL + '&text=' + encodedTitle,
      x: 'https://x.com/intent/tweet?url=' + encodedURL + '&text=' + encodedTitle
    };
    root.querySelectorAll('[data-scent-share-platform]').forEach(function (link) {
      var platform = link.dataset.scentSharePlatform;
      if (intents[platform]) link.href = intents[platform];
      if (platform === 'pinterest' && !socialImage) link.hidden = true;
    });
    root.dataset.scentShareReady = 'true';
    field.value = url;
    menu.hidden = false; copy.hidden = false; summary.hidden = true;
    if (close) close.hidden = false;
    function setOpen(open, returnFocus) {
      chooser.open = open;
      menu.setAttribute('aria-expanded', String(open));
      if (returnFocus) menu.focus();
    }
    chooser.addEventListener('toggle', function () { menu.setAttribute('aria-expanded', String(chooser.open)); });
    menu.addEventListener('click', function () { setOpen(!chooser.open, false); });
    if (close) close.addEventListener('click', function () { setOpen(false, true); });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && chooser.open) { event.preventDefault(); setOpen(false, true); }
    });
    document.addEventListener('pointerdown', function (event) {
      if (chooser.open && !root.contains(event.target)) setOpen(false, false);
    });
    function manualCopy(message) {
      setOpen(true, false); manual.open = true;
      field.focus(); field.select();
      status.textContent = message;
    }
    var copying = false;
    copy.addEventListener('click', async function () {
      if (copying) return;
      if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
        manualCopy(root.dataset.copyFallback); return;
      }
      copying = true; copy.disabled = true; copy.setAttribute('aria-busy', 'true'); status.textContent = '';
      try { await navigator.clipboard.writeText(url); status.textContent = root.dataset.copied; }
      catch (_) { manualCopy(root.dataset.copyFallback); }
      finally { copying = false; copy.disabled = false; copy.removeAttribute('aria-busy'); }
    });
    if (nativeButton && typeof navigator.share === 'function') {
      nativeButton.hidden = false;
      nativeButton.addEventListener('click', async function () {
        if (nativeButton.disabled) return;
        nativeButton.disabled = true; nativeButton.setAttribute('aria-busy', 'true'); status.textContent = '';
        try { await navigator.share({ title: title, url: url }); }
        catch (error) { if (!error || error.name !== 'AbortError') manualCopy(root.dataset.shareFallback); }
        finally { nativeButton.disabled = false; nativeButton.removeAttribute('aria-busy'); }
      });
    }
  }
  function boot(scope) { scope.querySelectorAll('[data-bk-scent-share]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());

/* One existing chapter outline, enhanced in place; never duplicate article content. */
(() => {
  'use strict';
  const initialise = root => {
    if (root.dataset.companionOutlineReady) return;
    const contents = [...root.children].find(node => node.matches('details.bk-ency__contents'));
    const summary = contents?.querySelector(':scope > summary');
    const links = contents ? [...contents.querySelectorAll('nav a[href^="#"]')] : [];
    const records = links.map(link => ({link, section: document.getElementById(link.hash.slice(1))}));
    if (!summary || records.length < 2 || records.some(row => !row.section || !root.contains(row.section))) return;
    const reading = [];
    for (let node = contents.nextSibling; node; node = node.nextSibling) {
      if (node.nodeType === 1 && node.matches('.bk-ency__related,.bk-ency__footer')) break;
      reading.push(node);
    }
    if (!reading.length) return;
    const reader = document.createElement('div'), body = document.createElement('div'), outline = document.createElement('aside');
    reader.className = 'bk-ency__companion-reader';
    body.className = 'bk-ency__companion-body';
    outline.className = 'bk-ency__companion-outline';
    outline.setAttribute('aria-label', summary.textContent.trim());
    contents.before(reader);
    reader.append(outline, body);
    outline.append(contents);
    reading.forEach(node => body.append(node));
    const progress = document.createElement('span');
    progress.className = 'bk-ency__outline-progress';
    progress.setAttribute('aria-hidden', 'true');
    summary.append(progress);
    root.dataset.companionOutlineReady = 'true';
    const compact = matchMedia('(max-width: 900px)');
    let queued = false;
    const setLayout = () => {
      if (compact.matches && contents.contains(document.activeElement) && document.activeElement !== summary) summary.focus();
      contents.open = !compact.matches;
      schedule();
    };
    const update = () => {
      queued = false;
      let headerBottom = 0;
      for (const header of document.querySelectorAll('#sticky-header,#page-header,sticky-header,.header-sticky,.header-middle')) {
        if (root.contains(header)) continue;
        const box = header.getBoundingClientRect(), position = getComputedStyle(header).position;
        if ((position === 'fixed' || position === 'sticky') && box.top <= 2 && box.bottom > 0) headerBottom = Math.max(headerBottom, box.bottom);
      }
      const barHeight = compact.matches ? summary.getBoundingClientRect().height : 0;
      root.style.setProperty('--ency-native-header', `${Math.ceil(headerBottom)}px`);
      root.style.setProperty('--ency-outline-clearance', `${Math.ceil(barHeight)}px`);
      const offset = headerBottom + barHeight + 60;
      let current = records[0];
      for (const record of records) if (record.section.getBoundingClientRect().top <= offset) current = record;
      records.forEach(record => {
        if (record === current) record.link.setAttribute('aria-current', 'location');
        else record.link.removeAttribute('aria-current');
      });
      progress.textContent = `${String(records.indexOf(current) + 1).padStart(2, '0')} / ${String(records.length).padStart(2, '0')}`;
      const readerBox = reader.getBoundingClientRect();
      const fixed = compact.matches && readerBox.top + 16 <= headerBottom && readerBox.bottom > headerBottom + barHeight + 31;
      root.style.setProperty('--ency-outline-left', `${readerBox.left}px`);
      root.style.setProperty('--ency-outline-width', `${readerBox.width}px`);
      outline.dataset.outlineStuck = String(fixed);
      reader.dataset.outlineFixed = String(fixed);
    };
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    contents.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      const target = records.find(record => record.link === link)?.section;
      if (!target) return;
      if (compact.matches) contents.open = false;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
      schedule();
    });
    contents.addEventListener('keydown', event => {
      if (event.key === 'Escape' && compact.matches && contents.open) {
        event.preventDefault(); contents.open = false; summary.focus();
      }
    });
    contents.addEventListener('toggle', schedule);
    compact.addEventListener('change', setLayout);
    addEventListener('scroll', schedule, {passive: true});
    addEventListener('resize', schedule, {passive: true});
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(summary);
      document.querySelectorAll('#sticky-header,#page-header').forEach(header => observer.observe(header));
    }
    document.querySelectorAll('#sticky-header,#page-header').forEach(header => {
      header.addEventListener('transitionend', schedule);
      if ('MutationObserver' in window) new MutationObserver(schedule).observe(header, {attributes: true, attributeFilter: ['class', 'style']});
    });
    setLayout();
    update();
  };
  const boot = scope => {
    if (scope.matches?.('.bk-ency--companion')) initialise(scope);
    scope.querySelectorAll('.bk-ency--companion').forEach(initialise);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
